import ClientSystem from "../../types/core/ClientSystem"
import UserDigest from "../../types/core/UserDigest";
import School from "../../types/core/School";

interface UserActivitySystem {
    active: boolean,
    systemID: number,
    clientSystem: ClientSystem
}

class UserActivity {
    schoolID: number;
    personID: number;
    userID: number;
    school: School;
    user: UserDigest;
    systems: UserActivitySystem[];

    get schoolName(): string {
        return this.school?.name ?? "";
    }

    constructor(data?: Partial<UserActivity>) {
        Object.assign(this, data);
    }
}

export default UserActivity;